import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { Input } from 'src/generic/component/form';
import { IFieldErrors, ErrorManager } from 'src/types/validation';

interface IDaySchedule {
  startTime?: string;
  endTime?: string;
}

interface IDayScheduleProps {
  day: string;
  schedule?: IDaySchedule;
  readOnly?: boolean;
  errors: IFieldErrors;
  onUpdate: (day: string, schedule: IDaySchedule) => void;
}

export const DaySchedule: FC<IDayScheduleProps> = ({
  day,
  schedule,
  readOnly,
  errors,
  onUpdate
}) => {
  const { getError, hasError } = ErrorManager(errors);

  const handleStartTimeChange = (value: string) => {
    onUpdate(day.toLowerCase(), {
      ...schedule,
      startTime: value
    });
  };

  const handleEndTimeChange = (value: string) => {
    onUpdate(day.toLowerCase(), {
      ...schedule,
      endTime: value
    });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '120px',
        margin: '0 8px'
      }}
    >
      {/* Day Header */}
      <Typography
        variant="body2"
        sx={{
          fontWeight: 'bold',
          marginBottom: '8px',
          textAlign: 'center'
        }}
      >
        {day}
      </Typography>

      {/* Start Time Row */}
      <Box sx={{ marginBottom: '8px', width: '100%' }}>
        <Typography variant="caption" sx={{ display: 'block', marginBottom: '4px' }}>
          Start Time
        </Typography>
        <Input
          disabled={readOnly}
          value={schedule?.startTime || ''}
          placeholder="08:00 AM"
          validation={hasError(`data.appForm.studentSchedule.daySchedule.${day.toLowerCase()}.startTime`) ? 'error' : undefined}
          validationMsg={getError(`data.appForm.studentSchedule.daySchedule.${day.toLowerCase()}.startTime`)}
          onChange={(e) => handleStartTimeChange(e.target.value)}
          style={{ width: '100%' }}
        />
      </Box>

      {/* End Time Row */}
      <Box sx={{ width: '100%' }}>
        <Typography variant="caption" sx={{ display: 'block', marginBottom: '4px' }}>
          End Time
        </Typography>
        <Input
          disabled={readOnly}
          value={schedule?.endTime || ''}
          placeholder="03:00 PM"
          validation={hasError(`data.appForm.studentSchedule.daySchedule.${day.toLowerCase()}.endTime`) ? 'error' : undefined}
          validationMsg={getError(`data.appForm.studentSchedule.daySchedule.${day.toLowerCase()}.endTime`)}
          onChange={(e) => handleEndTimeChange(e.target.value)}
          style={{ width: '100%' }}
        />
      </Box>
    </Box>
  );
};